import Api from "@/services/Api";

const state = {
	newUsers: null,
	newSites: null,
	users: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	emails: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	subscribers: {
		count: 0,
		type: "increase",
		percentage: 0
	},
	events: []
};

const getters = {
	getUsers: state => state.users,
	getEmails: state => state.emails,
	getSubscribers: state => state.subscribers,
	getEvents: state => state.events,
	getNewUsers: state => state.newUsers,
	getNewSites: state => state.newSites
};

const mutations = {
	getUsers(state, data) {
		state.users = data;
	},
	emailSent(state, data) {
		state.emails = data;
	},
	subscribersList(state, data) {
		state.subscribers = data;
	},
	getNewUsers(state, dataset) {
		let labels = [];
		let data = [];
		dataset.forEach(el => {
			labels.push(el.Day);
			data.push(el.count);
		});
		state.newUsers = { labels: labels, data: data };
	},
	getNewSites(state, dataset) {
		let labels = [];
		let data = [];
		dataset.forEach(el => {
			labels.push(el.Day);
			data.push(el.count);
		});
		state.newSites = {
			datasets: [{
				label: 'New site',
				backgroundColor: '#76edb5',
				borderWidth: 1,
				data: data
			}],
			labels: labels
		};
	},
	getEvents(state, data) {
		state.events = data;
	}
};

const actions = {
	getUsers({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let query = payload.query;
			if (!query) {
				query = 'last-30-days';
			}
			let url = `reports/users/total?q=${query}`;
			if (payload.refresh) {
				url += `&refresh=${payload.refresh}`
			}

			Api.get(url)
			.then(res => {
				commit('getUsers', res.data);
				resolve({ users: state.users });
			})
			.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	emailSent({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let query = payload.query;
			if (!query) {
				query = 'last-30-days';
			}
			let url = `reports/emails/sent?q=${query}`;
			if (payload.refresh) {
				url += `&refresh=${payload.refresh}`
			}

			Api.get(url)
			.then(res => {
				commit('emailSent', res.data);
				resolve({ emails: res.data });
			})
			.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	subscribersList({commit},payload) {
		return new Promise((resolve, reject) => {
			let query = payload.query;
			if (!query) {
				query = 'last-30-days';
			}
			let url = `reports/subscribers?q=${query}`;
			if (payload.refresh) {
				url += `&refresh=${payload.refresh}`
			}

			Api.get(url)
			.then(res => {
				commit('subscribersList', res.data);
				resolve({ data: res.data });
			})
			.catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	getNewUsers({commit}, payload) {
		return new Promise((resolve, reject) => {
			let query = payload.query;
			if (!query) {
				query = 'last-30-days';
			}
			let url = `reports/users/new?q=${query}`;
			if (payload.refresh) {
				url += `&refresh=${payload.refresh}`
			}

			Api.get(url).then(res => {
				commit('getNewUsers', res.data);
				resolve({ data: res.data });
			}).catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	getNewSites({commit}, payload) {
		return new Promise((resolve, reject) => {
			let query = payload.query;
			if (!query) {
				query = 'last-30-days';
			}
			let url = `reports/sites/new?q=${query}`;
			if (payload.refresh) {
				url += `&refresh=${payload.refresh}`
			}

			Api.get(url).then(res => {
				commit('getNewSites', res.data);
				resolve({ data: res.data });
			}).catch(err => this.$weNotify("error", err.response.data.message));
		});
	},
	getEvents({ commit }, payload) {
		return new Promise((resolve, reject) => {
			let url = `reports/event-logs`;
			if (payload.refresh) {
				url += `?refresh=${payload.refresh}`
			}

			Api.get(url).then(res => {
				payload.context.loading = false;
				commit('getEvents', res.data.data);
				resolve({ data: res.data.data });
			})
			.catch(err =>
				this.$weNotify("error", err.response.data.message)
			);
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
